import { BRANCHES } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';

export const Branch = {
	getBranches: () =>
		FetchAPI.getJson({
			urlStr: `${BRANCHES}`,
		}),
	getBranch: (id: string) =>
		FetchAPI.getJson({
			urlStr: `${BRANCHES}/${id}`,
		}),
};
